import { Box, Typography } from '@mui/material';
import Grid, { type GridProps } from '@mui/material/Grid';
import { memo } from 'react';
import { formatCurrency } from '../utils';
import '../bt-calculator.css';

type Props = {
  title: string;
  value: number;
  valueAnnotation: string;
  subtext?: string;
} & GridProps;

export const ResultCard = memo(
  ({ className, title, value, valueAnnotation, subtext, sx }: Props) => (
    <Grid
      className={className}
      size={{ xs: 12, sm: 4 }}
      sx={{
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'neutral.lighter',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        padding: 3,
        ...sx,
      }}
    >
      <Typography variant="textBold">{title}</Typography>
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
        <Typography variant="textBold" sx={{ fontSize: '36px', whiteSpace: 'nowrap' }}>
          {formatCurrency({ amount: value })}
        </Typography>
        <Typography
          variant="textSmall"
          sx={{ fontSize: '12px', minWidth: 0, flex: '1 1 25%', overflowWrap: 'break-word' }}
        >
          {valueAnnotation}
        </Typography>
      </Box>
      <Typography variant="textSmall">{subtext}</Typography>
    </Grid>
  ),
  (prevProps, nextProps) => {
    return prevProps.value === nextProps.value;
  },
);
